<template>
  <div>
    <script data-n-head="true" type="application/ld+json">{
      "@context":"http://schema.org",
      "@type":"BreadcrumbList","itemListElement":[
        {
          "@type":"ListItem",
          "position":1,
          "item":"https://GameEnable.com/","name":"Home"
        }
      ]
    }</script>
    <v-row  style="margin:0;     margin-bottom: -60px;">
      <v-col cols="12" style="    padding: 0;">
        <v-card
                color="rgb(32, 33, 36)"
                class="main-card"
                dark
        >
          <div class="page-content">
            <v-avatar
                    class="ma-5 float-right rtl hidden-sm-and-down"
                    size="380"
                    style="margin-top: -83px!important; margin-right: 30px!important; "
                    tile
            >
              <v-img
                      alt="Vuetify Logo"
                      class="shrink mr-2"
                      contain
                      src="../../assets/artwork-light.png"
                      transition="scroll-x-transition"
                      width="100%"

              />
            </v-avatar>
            <v-card-title class="headline text-wrap" style="padding-top:0;display: block;">
             <span v-if="false && isGeneric">
                {{$t('home.mainHeadlineTitleRow1_generic')}} &nbsp;<vue-typer style="color:#fff;" :text="['Stadia™', 'xCloud™']"  eraseStyle='backspace' :eraseDelay='50'></vue-typer>
              <br>
              {{$t('home.mainHeadlineTitleRow2')}}
             </span>
              <span v-if="true || !isGeneric">
                  {{$t('home.mainHeadlineTitleRow1', {platformName: modeParams.platformName})}}
              <br>
              {{$t('home.mainHeadlineTitleRow2')}}
              </span>

            </v-card-title>

            <v-card-subtitle><p v-html="$t('home.mainHeadlineSubtitle', {platformName: modeParams.platformName})"></p></v-card-subtitle>

            <v-card-actions>
              <v-btn  v-if="!signedIn" class="action-button try-now" @click="$emit('tryItNowDialogOpen')" v-ga-event="['User Activity', 'TryNow', 'Home page - card', 1]"  @click.stop="tryItNowDialogOpenInner = true"><span v-html="$t('home.cta')"></span></v-btn>
              <router-link  v-if="signedIn" class="action-button try-now"  :to="{ name: 'Account', params: { lang: this.$i18n.locale }}"><span v-html="$t('home.account')"></span></router-link>

            </v-card-actions>


            <v-card-subtitle style="padding-top: 0; font-weight: 200; padding-bottom: 0;"><p v-html="$t('home.ctaTerms')"></p></v-card-subtitle>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <div class="page-content">

      <v-row style="margin:0;">
        <v-col cols="12">
          <h1 class="text-center" style="margin-top: 40px; font-size: 48px;"><p v-html="$t('home.mostOutOfStadiaTitle', {platformName: modeParams.platformName})"></p></h1>
          <h1 class="text-center" style="font-weight:300;font-size:27px;"><p v-html="$t('home.mostOutOfStadiaSubtitle', {platformName: modeParams.platformNameVariant2})"></p></h1>
        </v-col>
      </v-row>

      <v-row style="margin:0;">
        <v-col cols="12" class="flex d-inline-flex flex-wrap justify-center mb-6">
          <v-col

                  v-for="techPoint in techPoints"
                  :key="techPoint.title"
          >

            <v-card

                    class="mx-auto"
                    style="display: inline-block;width:100%;box-sizing:border-box;height:200px;margin-bottom:5px;"
                    min-width="220"
                    outlined
            >
              <v-card-title class="headline mb-1 text-center">{{techPoint.title}} <v-icon  class="text-action float-right" :style="'position:absolute;' + ( $vuetify.rtl? 'left:15px;' : 'right:15px;' )" v-text="techPoint.icon" ></v-icon></v-card-title>
              <v-card-text style="word-break: initial; overflow: visible; text-overflow: initial;" v-html="techPoint.description"></v-card-text>


            </v-card>

          </v-col>
        </v-col>


      </v-row>

      <v-row style="min-height: 500px; background-color:rgb(251 251 251); margin:0;   margin-bottom: 60px;">
        <v-col  lg="6" md="6" sm="12" class="float-left" style="position:relative;" >

          <div class="platforms-seperator"></div>
          <v-card-title ><p v-html="$t('home.platformsSupportTitle')"></p></v-card-title>
          <v-card-text class="black--text pt-0">

            {{this.appName}} <span v-if="isGeneric" v-html="$t('home.platformsSupportSubtitle_generic', {platformName: modeParams.platformNameVariant2})"></span>
            <span v-if="!isGeneric" v-html="$t('home.platformsSupportSubtitle', {platformName: modeParams.platformName})"></span>
              &nbsp;<router-link  class="" style="text-decoration: none; color:rgb(233, 30, 99)"  :to="{ name: 'supported-platforms', params: { lang: this.$i18n.locale }}">{{$t('home.readMore')}}</router-link>

            <v-col lg="12" v-if="isGeneric">
              <v-col lg="6" md="6" sm="12" style="float:left;">
                   <h4>Stadia™</h4>
                 <v-list  style="margin-top:10px;background:transparent;display: inline-block;" dir="ltr">

              <v-list-item
                      v-for="subItem in modeParams.supportedPlatforms.stadia"
                      :key="subItem.title"

              >
                <v-list-item-content>
                  <v-list-item-title v-html="subItem.title"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-if="!subItem.soon"  class="text-action" v-text="subItem.soon? 'mdi-history' : 'mdi-check-circle'" ></v-icon>
                  <v-chip v-if="subItem.soon" class="ma-2"  small style="    margin-right: -7px!important;margin-bottom:0!important;margin-top:0!important;"><span v-html="$t('home.soon')"></span></v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
              </v-col>
              <v-col lg="6" md="6" sm="12" style="float:right;">
   <h4>xCloud™</h4>
                <v-list  style="margin-top:10px;background:transparent;display: inline-block;" dir="ltr">

              <v-list-item
                      v-for="subItem in modeParams.supportedPlatforms.xcloud"
                      :key="subItem.title"

              >
                <v-list-item-content>
                  <v-list-item-title v-html="subItem.title"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-if="!subItem.soon"  class="text-action" v-text="subItem.soon? 'mdi-history' : 'mdi-check-circle'" ></v-icon>
                  <v-chip v-if="subItem.soon" class="ma-2"  small style="    margin-right: -7px!important;margin-bottom:0!important;margin-top:0!important;"><span v-html="$t('home.soon')"></span></v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>

              </v-col>


            </v-col>


            <v-list v-if="!isGeneric" style="margin-top:10px;background:transparent;" dir="ltr">

              <v-list-item
                      v-for="subItem in modeParams.supportedPlatforms"
                      :key="subItem.title"

              >
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.title"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-if="!subItem.soon"  class="text-action" v-text="subItem.soon? 'mdi-history' : 'mdi-check-circle'" ></v-icon>
                  <v-chip v-if="subItem.soon" class="ma-2"  small style="    margin-right: -7px!important;margin-bottom:0!important;margin-top:0!important;"><span v-html="$t('home.soon')"></span></v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>

          </v-card-text>

        </v-col>
        <v-col lg="6" md="6" sm="12" class="float-right hidden-sm">
          <v-card-text class="black--text pt-0">
            <v-img
                    alt="Vuetify Logo"
                    class="shrink mr-2"
                    contain
                    src="../../assets/platforms.png"

                    width="100%"
            />
          </v-card-text>
        </v-col>
      </v-row>

        <!--<v-row  style="margin:0;margin: 0px 0px 60px;" class="pl-5 d-flex justify-center">-->
            <!--<h2 class="freeTrialBlock-text"> <span v-html="$t('home.3DayFreeTrialForNewUsersClaimNow')"></span></h2>-->
            <!--<v-btn class="float-left freeTrialBlock-button"   outlined color="pink" @click="$emit('tryItNowDialogOpen')" v-ga-event="['User Activity', 'TryNow', 'Home page - card', 1]"  @click.stop="tryItNowDialogOpenInner = true"><span v-html="$t('header.signIn')"></span></v-btn>-->

        <!--</v-row>-->



        <v-row style="min-height: 190px;  margin:0;   margin-bottom: 60px;">
            <v-col  lg="6" md="6" sm="12" class="float-left hidden-sm hidden-xs-only" style="position:relative;" >



                <v-card-text class="black--text pt-0 " >

                    <v-img
                            alt="Vuetify Logo"
                            class="shrink mr-2 "
                            contain
                            src="../../assets/megaphone.svg"

                            width="340"
                            style="    margin-bottom: -10px; margin-top: 27px;margin-left: auto; margin-right: auto!important;"
                    />

                </v-card-text>

            </v-col>
            <v-col lg="6" md="6" sm="12" class="float-right hidden-sm text-center">
                <v-card-title ><p v-html="$t('home.talkingAboutUs')"></p></v-card-title>
                <v-card-text class="black--text pt-0 d-flex justify-space-around ">
                    <span class="text-left" v-html="$t('home.talkingAboutUs_description')"></span>
                </v-card-text>
                <v-card-text class="black--text pt-0 d-flex justify-space-around " style="margin-top:-20px">

                    <router-link  class="" style="text-decoration: none; color:rgb(233, 30, 99);margin-top: auto; position: relative; top: 37px;"  :to="{ name: 'talking-about-us', params: { lang: this.$i18n.locale }}"><v-btn class="elevation-0" style="" text>{{$t('home.watchVideos')}}</v-btn></router-link>

                </v-card-text>
            </v-col>



        </v-row>

        <v-row style="margin:0;margin: 0px 0px 60px; background-color:rgb(251 251 251);">


            <v-col  lg="6" md="6" sm="12" class="float-left" style="position:relative;" >


                <v-card-title ><p v-html="$t('home.weGotYourBack')"></p></v-card-title>
                <v-card-text class="black--text pt-0">

                    <span v-html="$t('home.weAreReadyToAssistWithAnyInquiry', {platformName: modeParams.platformNameVariant2})"></span>

                    <v-flex class="contact-buttons-container d-flex justify-space-around mb-6 mt-16">
                        <v-btn color="purple"  class="contact-button" target="_blank" href="https://discord.gg/V6fv3Nx" outlined>  <v-icon class="contact-button-icon" color="purple">mdi-discord</v-icon> Discord</v-btn>
                        <div class="break"></div>
                        <v-btn color="#1DA1F2"  class="contact-button" target="_blank" href="https://twitter.com/enablegame" outlined>  <v-icon class="contact-button-icon" color="#1DA1F2">mdi-twitter</v-icon> Twitter</v-btn>
                        <div class="break"></div>
                        <v-btn color="red"  class="contact-button" target="_blank" href="mailto: gameenable.com@gmail.com" outlined>  <v-icon class="contact-button-icon" color="red">mdi-gmail</v-icon> Gmail</v-btn>

                    </v-flex>

                </v-card-text>

            </v-col>
            <v-col lg="6" md="6" sm="12" class="float-right hidden-sm hidden-xs-only text-center">
                <v-card-text class="black--text pt-0 d-flex justify-space-around ">
                    <v-img
                            alt="Vuetify Logo"
                            class="shrink mr-2 "
                            contain
                            src="../../assets/support.svg"
                            transition="scale-transition"
                            width="210"
                            style="    margin-bottom: -10px; margin-top: 27px;"
                    />
                </v-card-text>
            </v-col>
        </v-row>

    </div>

  </div>
</template>

<style>

    .mobile .contact-buttons-container {
        display: flex;
        flex-wrap: wrap;
    }

    .mobile .contact-button {
        width:100%;
        margin:15px 0;
    }

    .contact-button-icon {

        margin-right: 12px;

    }

    .rtl .contact-button-icon {

        margin-right: auto;
        margin-left: 12px;

    }

    .freeTrialBlock-button {
        position: relative;
        right: -50px;

    }

    .rtl .freeTrialBlock-button {
        position: relative;
        right:auto;
        left: -50px;

    }

    .small-screen .freeTrialBlock-text, .mobile  .freeTrialBlock-text{

        text-align:center;

    }

    .mobile  .freeTrialBlock-button{
        margin-top: 20px;
        right: auto;
    }

    .mobile .break {
        flex-basis: 100%;
        height: 0;
    }
  .vue-typer {
    font-family: inherit;
    font-size: inherit;
    color: white;
  }

  .vue-typer .custom.char.typed {
    color: #ffffff;
  }
  .vue-typer .custom.caret.typing {
    background-color: #ffffff;
  }
  .vue-typer .custom.caret {
    background-color: #ffffff;
  }

  .text-action {

    color: #EF44AE;
    background: linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

  }

  .try-now {
    width: auto!important;
  }

  .main-card {

    padding:160px 62px 62px 62px;

    position: relative; top: -74px!important; border-radius: 0!important;
  }

  .mobile .main-card {

    padding: 114px 20px 20px 20px;
  }

  .platforms-seperator {

    position: absolute; right: 0; height: 260px; border-right: 1px solid #cecece; top: 0; bottom: 0; margin: auto;

  }

  .rtl .platforms-seperator {

    right: auto;
    left: 0;

  }
</style>

<script>



  //import Vue from 'vue'
  import i18n from '@/i18n';
  import {mapState} from 'vuex';
  const appName = 'GameEnable';

  export default {
    name: 'Home',
    props: ['modeParams'],
    computed: {
        ...mapState(['signedIn', 'talkingAboutUsVideos']),
      isGeneric(){
        return this.modeParams.mode === 'generic';
      },
        randomTalkingAboutUsVideo(){

            // const randomIndex= Math.floor(Math.random()*this.talkingAboutUsVideos.length);

            return this.talkingAboutUsVideos[0];
        },
      techPoints() {
        return [
          {
            title: i18n.t('home.latencyTitle'),
            description: i18n.t('home.latencyContent'),
            icon: 'mdi-speedometer'
          },
          {
            title: i18n.t('home.freedomTitle'),
            description: i18n.t('home.freedomContent', {platformName: this.modeParams.platformNameVariant2}),
            icon: 'mdi-earth'
          },
          {
            title: i18n.t('home.securityTitle'),
            description: i18n.t('home.securityContent', {applicationName: this.modeParams.applicationName}),
            icon: 'mdi-security'
          },
          {
            title: i18n.t('home.privacyTitle'),
            description: i18n.t('home.privacyContent'),
            icon: 'mdi-lock'
          }];
      }
    },
    data: () => ({
      appName: appName,
        talkingAboutUs: 0
    })
  };
</script>
